import $ from 'jquery';

$( '.open-modal' ).on( 'click' , function( e ) {
  // Assigns the active class to the modal content for the clicked item, making it visible
  e.preventDefault();
  var target =(e.target).closest('.open-modal');
  var modal = target.nextElementSibling;
  modal.classList.add('active');

});

$( '.modal-overlay' ).on( 'click' , function( e ) {
  // Removes the active class to the modal content for the clicked item
  e.preventDefault();
  var embed = $(e.target).contents().find('iframe')[0];
  if (embed) {
    embed.remove();
  }
  $(e.target).removeClass('active');
});
